import * as apis from '../common-utils/api_urls';
import axios from 'axios';
//import {getAPIAuthKey,getHeaderAuthKey} from '../common-utils/apiconfig'
import { headerdatastatic } from '../common-utils/headerdatastatic.js';

import { getAPIAuthKeyHeaderFooter, getEnviorment, getHost, getSubscriptionKey } from '../common-utils/apiconfig';
import langData from '../common-utils/languagecodes.json';
import { wcTokenApi } from '../common-utils/salesLeadsApi';
import { Cookies } from 'react-cookie';



export function getVarificationUrl() {
  if (window.location.hostname.toLowerCase().indexOf('localhost') >= 0) {
    return `https://loginqa.parker.com/api/v1/sessions/me`;
  } else if (
    window.location.hostname.toLowerCase().indexOf('salesleadsdev') >= 0
  ) {
    return `https://logintest.parker.com/api/v1/sessions/me`;
  } else if (
    window.location.hostname.toLowerCase().indexOf('salesleadstest') >= 0
  ) {
    return `https://loginqa.parker.com/api/v1/sessions/me`;
  } else if (
    window.location.hostname.toLowerCase().indexOf('salesleadsstage') >= 0
  ) {
    return `https://loginstage.parker.com/api/v1/sessions/me`;
  } else if (
    window.location.hostname.toLowerCase().indexOf('salesleads.parker') >= 0
  ) {
    return `https://login.parker.com/api/v1/sessions/me`;
  } else {
    return `https://logintest.parker.com/api/v1/sessions/me`;
  }
}

export function getHeaderFooterURL() {
  if (window.location.hostname.toLowerCase().indexOf('salesleadsdev') >= 0) {
    return `https://apidev.parker.com/dev`;
  } else if (
    window.location.hostname.toLowerCase().indexOf('salesleadstest') >= 0
  ) {
    return `https://apidev.parker.com/test`;
  } else if (
    window.location.hostname.toLowerCase().indexOf('salesleadsstage') >= 0
  ) {
    return `https://api.parker.com/stage`;
  } else if (
    window.location.hostname.toLowerCase().indexOf('salesleads.parker') >= 0
  ) {
    return `https://api.parker.com/prod`;
  } else {
    return `https://apidev.parker.com/test`;
  }
}
export function getApiHostUrl(){
  if (window.location.hostname.toLowerCase().indexOf('salesleadsdev') >= 0) {
    return `https://devmy.parker.com/`;
  } else if (
    window.location.hostname.toLowerCase().indexOf('salesleadstest') >= 0
  ) {
    return `https://testmy.parker.com/`;
  } else if (
    window.location.hostname.toLowerCase().indexOf('salesleadsstage') >= 0
  ) {
    return `https://stagemy.parker.com/`;
  } else if (
    window.location.hostname.toLowerCase().indexOf('salesleads.parker') >= 0
  ) {
    return `https://my.parker.com/`;
  } else {
    return `https://testmy.parker.com/`;
  }
}
export function getBaseurl() {
  if (window.location.hostname.toLowerCase().indexOf('localhost') >= 0) {
    return 'http://localhost:5000/api';
  } else {
    return window.location.origin + '/api';
  }
}

export function varification() {
  try {
    const res = axios(getVarificationUrl(), {
      method: 'GET',
      withCredentials: true,
    })
      .then(function (result) {
        let response = result.data;
        window.sessionStorage.setItem('oktaSessionMeId', response.id);
        window.sessionStorage.setItem('oktaLogin', response.login);
        window.sessionStorage.setItem('oktaUserEmail', response.login);
        window.sessionStorage.setItem('oktaUserName', response._links.user.name);
        window.sessionStorage.setItem('oktaUserMeId', response.userId);
        
      })
      .catch(function (error) {
        window.sessionStorage.removeItem('oktaSessionMeId');
        window.sessionStorage.removeItem('oktaLogin');
        window.sessionStorage.removeItem('oktaUserEmail');
        window.sessionStorage.removeItem('oktaUserName');
        window.sessionStorage.removeItem('oktaUserMeId');
        document.cookie.split(';').forEach(function (c) {
          document.cookie = c
            .replace(/^ +/, '')
            .replace(
              /=.*/,
              '=;expires=' +
                new Date().toUTCString() +
                ';path=/; domain=.parker.com;'
            );
        });

        console.error(error);
      });

    // Don't forget to return something
    return null;
  } catch (error) {
    document.cookie.split(';').forEach(function (c) {
      document.cookie = c
        .replace(/^ +/, '')
        .replace(
          /=.*/,
          '=;expires=' +
            new Date().toUTCString() +
            ';path=/; domain=.parker.com;'
        );
    });
    window.sessionStorage.removeItem('oktaSessionMeId');
    window.sessionStorage.removeItem('oktaLogin');
    window.sessionStorage.removeItem('oktaLogin');
    console.error(error);
  }
}


export async function callHeaderFooter(cid, langCode, oktasessmeId, userId) {
  console.log('oktasessmeId-1', oktasessmeId);
  try {
    if (oktasessmeId === null) {
      let res = headerdatastatic;
      console.log('resHeader', res);
      return res;
    } else {
      let res = await axios({
        url:
          getHeaderFooterURL() +
          '/hf/myparker-html-header-footer?cid=' +
          cid +
          '&userId=' +
          userId +
          '&langCode=' +
          langCode +
          '&supportAllLoc=true&orglist=true',
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          'ocp-apim-subscription-key': getAPIAuthKeyHeaderFooter(),
        },
      });
      return res;
    }
  } catch (err) {
    console.error(err);
  }
}

export async function callHeaderFooter_local(cid, langCode, oktasessmeId, userId) {
  try {

let res = await axios.post(
      getBaseurl()+'/http-request-proxy',
      {
        url: `headerFooter`,
        method: 'get',
        params:  {
        cid: cid,
        langCode: langCode,
        userId: userId,
        },
      });
    //let res = headerdatastatic;
    // Don't forget to return something
    return res.data;
    //return res;
  } catch (err) {
    console.error(err);
  }
}

export async function getOrgList(history) {
  let curr_cid = window.location.search.includes('cid')
    ? window.location.search.split('?cid=')[1]
    : null;
  try {
    
    let res = await axios.post(
      getBaseurl()+'/http-request-proxy',
      {
        url: `orgList`,
        method: 'get',
        params:  {
        logonId: window.sessionStorage.getItem('oktaLogin')
        },
      });
    let cont_contraId = '';
    let org_array = [];
    //let org_string = '';
    let tt = '';
    if (curr_cid === null) {
      res.data['header']['orgList'].map((orgItemm) => {
        if (orgItemm.isDefault) {
          cont_contraId = orgItemm.cid;
          sessionStorage.setItem('isDefaultCustomerId', cont_contraId);
           sessionStorage.setItem('customerId', orgItemm.legalId);
          //console.log('history inside varification===', history);
          history.push({
            pathname: history.location.pathname,
            search: '?cid=' + cont_contraId,
          });
        }
        tt = org_array.push(orgItemm.legalId);
        var array = org_array;
        tt = array.slice(0, 40).map((x) => `'${x}'`).join(',');
        // console.log(array.map(x=>`'${x}'`).toString())
    
        sessionStorage.setItem('completeOrgLegalId', tt);
      });
    }else{
      res.data['header']['orgList'].map((orgItemm) => {
      
        if (orgItemm.isDefault) {
          cont_contraId = orgItemm.cid;
          sessionStorage.setItem('isDefaultCustomerId', cont_contraId);
          //console.log("Orglist==",orgItemm)
          // sessionStorage.setItem('customerId', orgItemm.legalId);           
        }
        tt = org_array.push(orgItemm.legalId);
        var array = org_array;
        tt = array.slice(0, 40).map((x) => `'${x}'`).join(',');
        // console.log(array.map(x=>`'${x}'`).toString())
        sessionStorage.setItem('completeOrgLegalId', tt);
      });
    }
  
    //console.log('NewOrgList ===', org_array);
    //let res = headerdatastatic;
    // Don't forget to return something
    return res.data['header'];
    //return res;
  } catch (err) {
    console.error(err);
  }
}
// get default language start
export async function getWcToken() {
  const getToken = JSON.parse(window.localStorage.getItem('okta-token-storage'));
  const accessToken = getToken['accessToken']['accessToken'];
 // console.log('i am in  wcToken');
  const cookies = new Cookies();
  try {
    
    let res = await axios.post(
      getBaseurl()+'/http-request-proxy',
      {
        url: `wcTokenApi`,
        method: 'post',
        body:  {
        logonId: window.sessionStorage.getItem('oktaLogin'),
        oktaSessionId: accessToken
      },
     
      }
    )
    // Don't forget to return something
    //console.log("wcToken==",res)
    if(res.data!==null && res.data!==undefined){
      window.sessionStorage.setItem('WCToken', btoa(res.data['WCToken']));
      window.sessionStorage.setItem('WCTrustedToken', btoa(res.data['WCTrustedToken']));
      window.sessionStorage.setItem('userId', res.data['userId']);
      
      // console.log("WcToken =",res.data['WCToken']);
       //console.log("WCTrustedToken =", {path:'/',domain:'.parker.com'});

      /* WCToken and WCTrusted set into cookies */

      cookies.set(getEnviorment()+'_WCToken', decodeURIComponent(res.data['WCToken']),{ path: '/',
    domain: '.parker.com',
    secure: true,
    sameSite: 'lax',
    maxAge: 24 * 60 * 60});
      cookies.set(getEnviorment()+'_WCTrustedToken', decodeURIComponent(res.data['WCTrustedToken']),{ path: '/',
    domain: '.parker.com',
    secure: true,
    sameSite: 'lax',
    maxAge: 24 * 60 * 60});
   
      //getDefaultLang()
      return null; //res.data;
      //return res;
    }
  } catch (err) {
    console.error(err);
  }
}

export async function getDefaultLang() {
  const DEFAULT_LANG = 'en';
  
  try {
    // Get domain and auth tokens
    let domainName = getHeaderFooterURL().replace('/prod', '');
    const wcToken = atob(window.sessionStorage.getItem('WCToken'));
    const wcTrustedToken = atob(window.sessionStorage.getItem('WCTrustedToken'));
    
    // Get user's language preference
    // const res = await axios({
    //   url: `${domainName}/myparker/adminapi/getUserDefaultLocationAndLang?userEmail=${sessionStorage.getItem("oktaLogin")}`,
    //   method: 'get',
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'ocp-apim-subscription-key': getSubscriptionKey(), 
    //   },
    // });
    let res = await axios.post(
      getBaseurl()+'/http-request-proxy',
      {
        url: `getDefaultLang`,
        method: 'get',
        params:  {
        logonId: window.sessionStorage.getItem('oktaLogin') 
      },
     
      }
    );

    // Extract language info
    const langId = res?.data?.langID;
    if (!langId) {
      return redirectToLanguage(DEFAULT_LANG);
    }

    const customerLang = langData[langId];
    if (!customerLang) {
      return redirectToLanguage(DEFAULT_LANG);
    }

    const currentLang = window.location.pathname.substring(
      window.location.pathname.lastIndexOf('/') + 1
    );

    // Update language if needed
    window.sessionStorage.setItem('defaultLang', customerLang);
    if (currentLang.toLowerCase() !== customerLang.toLowerCase()) {
      return redirectToLanguage(customerLang);
    }

    return customerLang;

  } catch (err) {
    console.error('Error getting default language:', err);
    return redirectToLanguage(DEFAULT_LANG);
  }
}

// Helper function to handle redirects
function redirectToLanguage(lang) {
  window.sessionStorage.setItem('defaultLang', lang);
  
  const newPath = window.location.pathname.replace(
    window.location.pathname.substring(window.location.pathname.lastIndexOf('home/')),
    `home/${lang}`
  );
  
  window.location.href = `${window.location.origin}${newPath}${window.location.search}`;
  return lang;
}
// get default language end


export async function callApiToFetchIP() {
  try {
    const response = await axios.get(getApiHostUrl()+'api/user-ip-address',
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
    );
       
     // setClientIp(response.data.ip_address)
     
     window.sessionStorage.setItem('clientIp', response.data.ip_address);
      console.log("ip",response.data.ip_address)
  } catch (error) {
    console.error('Error:', error);
  }
}
